import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class {
  constructor() {
		this.hero = document.querySelector('.js-job-hero');
		this.heroBg = document.querySelector('.js-job-hero__img');
		//this.name = document.querySelector('.js-job-hero__name');
		this.copy = document.querySelector('.js-job-hero__copy');
    this.job();
  }

	job() {
		//const hero = this.hero;
		//if (hero) {
		//	const img = this.heroBg;
		//	const heroH = hero.clientHeight / 2;
		//	const name = this.name;
		//	const copy = this.copy;
		//	gsap.to( hero, {
		//		scrollTrigger: {
		//			//markers: true,
		//			trigger: img,
		//			start: 'top top',
		//			end: `+=${heroH}`,
		//			pin: true,
		//		}
		//	});
		//	gsap.set(copy,{
		//		opacity: 0,
		//	})
		//	gsap.to( copy, {
		//		opacity: 1,
		//		scrollTrigger: {
		//			//markers: true,
		//			trigger: copy,
		//			start: '50% 75%',
		//		}
		//	});
		//}
		// 現在のURLを取得
		const currentURL = window.location.href;
		// 末尾が #information であるかをチェック
		window.addEventListener('load', () => {
			if (currentURL.endsWith("#information")) {
					// アンカーリンク先の要素へスムーススクロール
					const targetElement = document.getElementById("information");
					if (targetElement) {
							window.scrollTo({
									top: targetElement.offsetTop,
									behavior: 'smooth' // スムーズなスクロール
							});
					}
			}
		})
  }
}